import axios from "axios";
import useTaskForm from "src/hooks/api/tasks/useTaskForm";
import useGet from "src/hooks/rest/useGet";
import useQueryString from "src/hooks/useQueryString";
import { getHoursBetweenDates } from "src/lib/dates";
import uid from "src/lib/uid";

function useFillTask() {
	const { actions } = useTaskForm();
	const { repeat, c, title, budget, status } = useQueryString();
	const { profile } = useQueryString();
	const [{ data: student }] = useGet(
		profile ? `/connections/${profile}` : undefined
	);

	const listeners = [student, repeat, title, budget, c, profile, status];

	const fill = () => {
		actions.clear();
		actions.setStatus("filling");
		//Check if empty params
		if (listeners.filter((i) => i).length === 0) {
			setTimeout(() => {
				actions.setStatus("idle");
			}, 500);
			return;
		}
		if (student) {
			actions.set(
				{
					student,
					student_hid: student.hid,
				},
				"fill"
			);
			actions.setStatus("idle");
			return;
		}
		if (repeat) {
			axios
				.get(`/company/tasks/${repeat}`)
				.then(({ data }: any) => {
					let questions = null;
					let subtasks = undefined;
					const task = data?.data || {};
					if (task.questions) {
						questions = task.questions.map((question: any) => {
							let item = {
								title: question.title,
								answers: (question?.choices || []).map(
									(item: any) => ({
										answer: item.answer,
										is_right: item.is_right,
									})
								),
							};
							return item;
						});
					}

					if (task.subtasks) {
						task.budget = null;
						task.amount_of_students = null;
						subtasks = task.subtasks.map((subtask: any) => ({
							_id: uid(),
							title: subtask.title,
							budget: subtask.budget,
							amount_of_students: subtask.amount_of_students,
							start_date: subtask.start_date,
							end_date: subtask.end_date,
							estimated_duration: getHoursBetweenDates(
								subtask.start_date,
								subtask.end_date
							),
							budget_per_hour: subtask.budget_per_hour,
						}));
					}

					const duplicatedTask = {
						title: task.title,
						description: task.description,
						category_id: task.category_id,
						amount_of_students: task.amount_of_students,
						budget: !task?.budget_per_hour ? task.budget : null,
						budget_per_hour: task.budget_per_hour,
						address: task.address,
						is_home: task.is_home,
						is_office: task.is_office,
						media: task.media,
						estimated_duration: task.estimated_duration,
						is_private: task.is_private,
						is_anonymous: task.is_anonymous,
						questions,
						subtasks,
						min_age: task?.age?.min || null,
						students: [],
					};
					actions.set(duplicatedTask, "fill");
				})
				.finally(() => {
					actions.setStatus("idle");
				});
			return;
		}
		if (title || budget || status) {
			actions.set(
				{
					amount_of_students: 1,
					title,
					budget,
					status,
				},
				"merge"
			);
			setTimeout(() => {
				actions.setStatus("idle");
			}, 100);
			return;
		}
	};
	return { fill, listeners };
}

export default useFillTask;
